/**
 * Erkennt, ob auf dem Server eine neuere Programmversion liegt als die, die
 * im geöffneten Tab läuft (KArs 23.09.2026 Teil 2, IV).
 *
 * „Ich kann alle Neuerungen aus dem Dokument vom 23.9.2026 bei mir nicht
 * sehen": Ein Tab, der seit vor dem Update offen ist, lädt die neuen
 * Programmteile nie nach. index.html wird ohne Cache ausgeliefert; die
 * Programmdateien tragen einen Hash im Namen (index-AbC123.js). Weicht der
 * Name in der aktuellen index.html vom geladenen ab, gibt es ein Update.
 */

const ENTRY_PATTERN = /<script[^>]+type=["']module["'][^>]*\ssrc=["']([^"']*\/assets\/[^"']+\.js)["']/i

/** Liefert den Pfad des Einstiegs-Skripts aus einem index.html-Text. */
export function entryScriptFromHtml (html: string): string | null {
  const match = ENTRY_PATTERN.exec(html || '')
  return match?.[1] ? normalizePath(match[1]) : null
}

/** Liefert den Pfad des Einstiegs-Skripts der laufenden Seite. */
export function currentEntryScript (doc: Document = document): string | null {
  const scripts = Array.from(doc.querySelectorAll<HTMLScriptElement>('script[type="module"][src]'))
  const entry = scripts.find((s) => /\/assets\/[^/]+\.js$/.test(normalizePath(s.src)))
  return entry ? normalizePath(entry.src) : null
}

/** true, wenn beide Einstiege bekannt sind und sich unterscheiden. */
export function isNewerVersion (loaded: string | null, served: string | null): boolean {
  return !!loaded && !!served && loaded !== served
}

function normalizePath (src: string): string {
  try {
    return new URL(src, 'http://localhost').pathname
  } catch {
    return src
  }
}
